var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "footer-link-column caption"
  }, [_c('div', {
    staticClass: "column-header"
  }, [_vm._m(0), _c('div', {
    staticClass: "overline"
  }, [_vm._v(_vm._s(_vm.$t('footer.sitemap')))])]), _c('router-link', {
    staticClass: "info-row",
    attrs: {
      "to": {
        name: 'IndexPage'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.seu')))]), _c('router-link', {
    staticClass: "info-row",
    attrs: {
      "to": {
        name: 'ChallengesPage',
        params: {
          slug: 'challenges',
          lang: _vm.lang
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.challenges')))]), _c('router-link', {
    staticClass: "info-row",
    attrs: {
      "to": {
        name: 'StrategyPage',
        params: {
          slug: _vm.getSlug('strategy'),
          lang: _vm.lang
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.strategy')))]), _c('router-link', {
    staticClass: "info-row",
    attrs: {
      "to": {
        name: 'OfferPage',
        params: {
          slug: _vm.getSlug('services'),
          lang: _vm.lang
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.services')))]), _c('router-link', {
    staticClass: "info-row",
    attrs: {
      "to": {
        name: 'FieldsPage',
        params: {
          slug: _vm.getSlug('engineering'),
          lang: _vm.lang
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.engineering')))]), _c('router-link', {
    staticClass: "info-row",
    attrs: {
      "to": {
        name: 'AboutUsPage',
        params: {
          slug: _vm.getSlug('about'),
          lang: _vm.lang
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.about')))]), _c('router-link', {
    staticClass: "info-row",
    attrs: {
      "to": {
        name: 'PostsPage'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.blog')))]), _c('router-link', {
    staticClass: "info-row",
    attrs: {
      "to": {
        name: 'ContactUsPage',
        params: {
          slug: _vm.getSlug('contact'),
          lang: _vm.lang
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('footer.contact')))])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icons/arrow-right-black-extended.svg"),
      "alt": ""
    }
  })]);

}]

export { render, staticRenderFns }